/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FileNoneIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="15 12.55 15 0 1 0 1 16 11.55 16 15 12.55"/>,
  ]
  getViewBox = () => '0 0 16 16'
}
